import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import MenuItem from "@material-ui/core/MenuItem";
import CircularProgress from "@material-ui/core/CircularProgress";
import TextField from "@material-ui/core/TextField";
import Snackbar from "@material-ui/core/Snackbar";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import {
  GetCityByProvinceId,
  GetProvinces,
  AddFestival,
  EditFestival,
  GetFestival,
  Upload,
} from "../../fetchs";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const useStyles = (theme) => ({
  appBar: {
    position: "relative",
  },
  layout: {
    width: "auto",
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
      width: 600,
      marginLeft: "auto",
      marginRight: "auto",
    },
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
  },
  stepper: {
    padding: theme.spacing(3, 0, 5),
  },
  buttons: {
    display: "flex",
    justifyContent: "flex-end",
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  labelAsterisk: {
    color: "red",
  },
  cssLabel: {
    color: "orange",
  },
  cssRequired: {
    "&:before": {
      borderBottom: "2px solid orange",
    },
  },
});

class Festival extends Component {
  constructor(props) {
    super(props);

    this.state = {
      id: "",
      name: "",
      nameHelper: "",
      cityId: null,
      imageAddress: "",
      description: "",
      cities: [],
      loading: false,
      saving: false,
      openSnackbar: false,
      errorMessage: "",
      province: [],
      provinceId: null,
      flag: false,
    };
  }

  handleChangeProvince = (name) => (event) => {
    this.setState({ [name]: event.target.value }, () => {
      this.getCitiesByProvince();
    });
  };

  getCitiesByProvince = () => {
    // if (!this.props.match.params.productId) {
    GetCityByProvinceId(this.state.provinceId)
      .then((response) => {
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.Message)
          this.setState({
            errorMessage: responseJson.Message,
            openSnackbar: true,
          });
        else this.setState({ cities: responseJson });
      })
      .catch((error) => {
        console.error(error);
      });
    // }
  };

  handleCloseSnackbar = () => {
    this.setState({ openSnackbar: false });
  };
  // handleChangeProvince = () => {
  //   if (this.state.provinceId) {
  //     GetCityByProvinceId(this.state.provinceId)
  //       .then((response) => {
  //         return response.json();
  //       })
  //       .then((responseJson) => {
  //         if (responseJson.Message)
  //           this.setState({
  //             errorMessage: responseJson.Message,
  //             openSnackbar: true,
  //           });
  //         else this.setState({ cities: responseJson });
  //       })
  //       .catch((error) => {
  //         console.error(error);
  //       });
  //   }
  // };

  componentDidMount() {
    GetProvinces(0, 999)
      .then((response) => {
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.Message)
          this.setState({
            errorMessage: responseJson.Message,
            openSnackbar: true,
          });
        else this.setState({ province: responseJson });
      })
      .catch((error) => {
        console.error(error);
      });
    const id = this.props.match.params.festivalId;
    if (id) {
      this.loadFestival(id);
    }
    // GetAllCities()
    //   .then((response) => {
    //     this.setState({ loading: false });
    //     return response.json();
    //   })
    //   .then((responseJson) => {
    //     if (responseJson.Message)
    //       this.setState({
    //         errorMessage: responseJson.Message,
    //         openSnackbar: true,
    //       });
    //     else this.setState({ cities: responseJson });
    //   })
    //   .catch((error) => {
    //     this.setState({ loading: false });
    //     console.log(error);
    //   });
  }

  loadFestival = (id) => {
    this.setState({ loading: true });
    GetFestival(this.props.match.params.festivalId)
      .then((response) => {
        this.setState({ loading: false });
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.Message)
          this.setState({
            errorMessage: responseJson.Message,
            openSnackbar: true,
          });
        else
          this.setState({
            id: responseJson.festival.id,
            name: responseJson.festival.name,
            imageAddress: responseJson.festival.imageAddress,
            provinceId: responseJson.festival.provinceId,
            cityId: responseJson.festival.cityId,
            description: responseJson.festival.description,
          });
      })
      .catch((error) => {
        this.setState({ loading: false });
        console.log(error);
      });
  };

  handleSave = () => {
    if (this.props.match.params.festivalId) this.editFestival();
    else this.addFestival();
  };

  addFestival = () => {
    AddFestival({
      name: this.state.name,
      imageAddress: this.state.imageAddress,
      cityId: this.state.cityId,
      provinceId: this.state.provinceId,
      description: this.state.description,
    })
      .then((response) => {
        if (response.status !== 200) {
          toast.error("خطای اضافه شدن جشنواره");
        } else if (response.status === 200) {
          toast.success(" جشنواره با موفقیت اضافه شد");
          this.props.history.push("/main/festivals");
        }
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.Message)
          this.setState({
            errorMessage: responseJson.Message,
            openSnackbar: true,
          });
      })
      .catch((error) => {
        console.error(error);
      });
  };

  editFestival = () => {
    EditFestival({
      id: this.props.match.params.festivalId,
      name: this.state.name,
      provinceId: this.state.provinceId,
      imageAddress: this.state.imageAddress,
      cityId: this.state.cityId,
      description: this.state.description,
    })
      .then((response) => {
        if (response.status !== 200) {
          toast.error("خطای ویرایش شدن جشنواره");
        } else if (response.status === 200) {
          toast.success(" جشنواره با موفقیت ویرایش شد");
          this.props.history.push("/main/festivals");
        }
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.Message)
          this.setState({
            errorMessage: responseJson.Message,
            openSnackbar: true,
          });
      })
      .catch((error) => {
        console.error(error);
      });
  };

  handleChangeProvince = (name) => (event) => {
    this.setState({ [name]: event.target.value }, () => {
      this.getCitiesByProvince();
    });
  };

  getCitiesByProvince = () => {
    // if (!this.props.match.params.productId) {
    GetCityByProvinceId(this.state.provinceId)
      .then((response) => {
        return response.json();
      })
      .then((responseJson) => {
        if (responseJson.Message)
          this.setState({
            errorMessage: responseJson.Message,
            openSnackbar: true,
          });
        else this.setState({ cities: responseJson });
      })
      .catch((error) => {
        console.error(error);
      });
    // }
  };

  handleChange = (name) => (event) => {
    this.setState({ [name]: event.target.value });
  };

  handleSelectFile = (event) => {
    Upload(event.target.files[0], "goods")
      .then((response) => {
        return response.text();
      })

      .then((responseJson) => {
        this.setState({ imageAddress: responseJson });
      })
      .catch((error) => {
        console.error(error);
      });
  };
  onchange = (event) => {
    let valid;

    switch (event.target.id) {
      case "name":
        this.setState({ name: event.target.value });
        valid = event.target.value.length > 0;
        if (!valid) {
          this.setState({ nameHelper: "لطفا نام را وارد کنید" });
        } else {
          this.setState({ nameHelper: "" });
        }

        break;

      default:
        break;
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <CssBaseline />
        <main className={classes.layout}>
          <Paper className={classes.paper}>
            {this.props.match.params.festivalId ? (
              <Typography component="h1" variant="h4" align="center">
                ویرایش جشنواره
              </Typography>
            ) : (
              <Typography component="h1" variant="h4" align="center">
                افزودن جشنواره جدید
              </Typography>
            )}
            <React.Fragment>
              <form className={classes.container} noValidate autoComplete="off">
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      error={this.state.nameHelper.length !== 0}
                      helperText={this.state.nameHelper}
                      onChange={this.onchange}
                      id="name"
                      label="نام"
                      required
                      fullWidth
                      className={classes.textField}
                      value={this.state.name}
                      margin="normal"
                      InputLabelProps={
                        this.state.name.length === 0
                          ? {
                              classes: {
                                root: classes.cssLabel,
                              },
                              FormLabelClasses: {
                                asterisk: classes.labelAsterisk,
                              },
                            }
                          : ""
                      }
                      InputProps={
                        this.state.name.length === 0
                          ? {
                              classes: {
                                underline: classes.cssRequired,
                              },
                            }
                          : ""
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      InputLabelProps={
                        this.state.provinceId === null
                          ? {
                              classes: {
                                root: classes.cssLabel,
                              },
                              FormLabelClasses: {
                                asterisk: classes.labelAsterisk,
                              },
                            }
                          : ""
                      }
                      InputProps={
                        this.state.provinceId === null
                          ? {
                              classes: {
                                underline: classes.cssRequired,
                              },
                            }
                          : ""
                      }
                      id="standard-select-city"
                      select
                      label="استان"
                      required
                      fullWidth
                      className={classes.textField}
                      value={this.state.provinceId}
                      onChange={this.handleChangeProvince("provinceId")}
                      SelectProps={{
                        MenuProps: {
                          className: classes.menu,
                        },
                      }}
                      margin="normal"
                    >
                      {this.state.province.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                          {option.name} - {option.province}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      InputLabelProps={
                        this.state.cityId === null
                          ? {
                              classes: {
                                root: classes.cssLabel,
                              },
                              FormLabelClasses: {
                                asterisk: classes.labelAsterisk,
                              },
                            }
                          : ""
                      }
                      InputProps={
                        this.state.cityId === null
                          ? {
                              classes: {
                                underline: classes.cssRequired,
                              },
                            }
                          : ""
                      }
                      id="standard-select-city"
                      select
                      label="شهر"
                      required
                      fullWidth
                      className={classes.textField}
                      value={this.state.cityId}
                      onChange={this.handleChange("cityId")}
                      SelectProps={{
                        MenuProps: {
                          className: classes.menu,
                        },
                      }}
                      margin="normal"
                    >
                      {this.state.cities.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                          {option.name} - {option.province}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  <Grid item xs={12}>
                    <div>
                      <input
                        accept="image/*"
                        className={classes.input}
                        style={{ display: "none" }}
                        id="raised-button-file"
                        multiple
                        type="file"
                        onChange={this.handleSelectFile}
                      />
                      <label htmlFor="raised-button-file">
                        <Button
                          fullWidth
                          variant="contained"
                          component="span"
                          className={classes.button}
                        >
                          ارسال عکس
                        </Button>
                        {this.state.uploadPic && (
                          <CircularProgress
                            size={24}
                            className={classes.buttonProgress}
                          />
                        )}
                      </label>
                    </div>
                    <div>
                      <div className="picParent">
                        <img
                          src={`http://test.asa-oil.ir/${this.state.imageAddress}`}
                          className="picture"
                          alt={this.state.name}
                        />
                      </div>
                    </div>
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      id="standard-description"
                      label="توضیحات"
                      multiline
                      rows="4"
                      fullWidth
                      className={classes.textField}
                      value={this.state.description}
                      onChange={this.handleChange("description")}
                      margin="normal"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      variant="contained"
                      color="primary"
                      fullWidth
                      disabled={
                        this.state.loading ||
                        this.state.nameHelper.length !== 0 ||
                        this.state.name.length === 0 ||
                        this.state.provinceId === null ||
                        this.state.cityId === null
                      }
                      onClick={this.handleSave}
                    >
                      ذخیره
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </React.Fragment>
          </Paper>
          <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            autoHideDuration={3000}
            open={this.state.openSnackbar}
            ContentProps={{
              "aria-describedby": "message-id",
              class:
                "error MuiTypography-root MuiPaper-root MuiPaper-elevation6 MuiSnackbarContent-root MuiTypography-body2",
            }}
            message={<span id="message-id"> {this.state.errorMessage} </span>}
            onClose={() => this.handleCloseSnackbar(false)}
          />
        </main>
      </React.Fragment>
    );
  }
}

Festival.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withRouter(withStyles(useStyles)(Festival));
